// test2096
(2096 && 0);
